var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"float-left"}),( _vm.$route.fullPath == '/posts' || _vm.$route.fullPath == '/posts/unpublished')?_c('router-link',{staticClass:"btn-basic float-right mt-4",attrs:{"to":"/posts/new-post"}},[_vm._v("New Post")]):_vm._e(),_c('br'),_c('br'),_c('br'),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }